import { Button } from "ui/button/button";
import { type ButtonProps } from "ui/button/button.types";

import Icons from "assets";

/** Figma's "‹ Back to …" for the `steps` footer: a large text button with a leading chevron. */
export const DialogBackButton = (props: Omit<ButtonProps, "variant" | "size" | "startIcon">) => (
  <Button {...props} variant="text" size="large" startIcon={<Icons.ChevronLeft />} />
);
